import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {Button, Checkbox, IconAdd, IconDelete, Spinner} from "@seismic/mantle";
import {initRecommendationStream, search, submitFeedback} from "../api/client";
import {Header} from "../components/Header";

const Content = (props) => {
    
    const getContent = () => {
        let toReturn = {...props};
        delete toReturn.addContent;
        return toReturn;
    }
    
    if(props.addContent)
        return <div style={{cursor: "pointer"}} onClick={() => props.addContent(getContent())} className="pt-1 pb-1">
                <IconAdd size={16} />
                {/*<img src={`https://bss-gn100.seismic.com/api/image/v1/quake/quake/${props.thumbnailId}?requestSize=Small`} width={48} height={32} />*/}
                <span className="ps-1">{props.name}</span>
            </div>

    return <div style={{cursor: "pointer"}} onClick={() => props.removeContent(getContent())} className="pt-1 pb-1">
        <IconDelete size={16} />
        <span className="ps-1">{props.name}</span>
    </div>
}

const ContentPicker = (props) => {

    const [searchTerm, setSearchTerm] = useState("");
    const [searching, setSearching] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    
    const searchChanged = (e) => {
        setSearchTerm(e.target.value);
    }
    
    const doSearch = async (term) => {
        try{
            setSearching(true);
            setSearchResults([]);
            let result = await search(term);
            setSearchResults(result);
        }
        finally {
            setSearching(false);
        }
    }
    
    const performSearch = async (e) => {
        if (e.key !== "Enter") return;
        await doSearch(searchTerm);
    }

    useEffect(() => {
        doSearch("");
    }, []);

    return <>
        <div>
            <input placeholder="Search for content.." onChange={searchChanged} onKeyPress={performSearch} className="w-100" type="text" />
        </div>
        <div className="border border-1" style={{height: "100px", overflow: "auto"}}>
            {searching ? <center className="p-4"><Spinner /></center> : searchResults.map(r => <Content key={r.contentId} {...r} addContent={props.addContent} />)}
        </div>
    </>
}

export const Livesend = () => {
    
    const dispatch = useDispatch();
    const [content, setContent] = useState([]);
    const [generating, setGenerating] = useState(false);
    const [comments, setComments] = useState("");
    const [recommendation, setRecommendation] = useState(null);
    const [subject, setSubject] = useState(null);
    const [body, setBody] = useState(null);
    const [allowCache, setAllowCache] = useState(true);
    const [exception, setException] = useState(null);
    const [emailGenerationTook, setEmailGenerationTook] = useState(null);
    const [recommendationError, setRecommendationError] = useState(null);
    const [recommendationSent, setRecommendationSent] = useState(false);
    const [templates] = useState([{
        key: "Default Sales Email",
        value: "Create a sales email from <Seller><SellerTitle> to <Buyer> where we send <ContentDetails> that contains the following content:<Content>"
    }, {
        key: "Brief Sales Email",
        value: "Create a brief sales email from <Seller><SellerTitle> to <Buyer> where we <ContentDetails> that contains the following content:<Content>"
    }]);
    const [selectedTemplate, setSelectedTemplate] = useState(templates[0].value);
    const [email, setEmail] = useState("stevep@microsoft.com");
    
    const addContent = (toAdd) => {
        if(!content.find(c => c.contentId === toAdd.contentId)) {
            setContent([...content, toAdd]);
        }
    }
    
    const selectedTemplateChanged = (e) => {
        setSelectedTemplate(e.target.value);
    }

    const changeTemplateValue = (e) => {
        setSelectedTemplate(e.target.value);
    }

    const sendFeedback = async (status) => {
        let feedback = {
            recommendation: recommendation,
            status: status,
            comments: comments
        }
        await submitFeedback(feedback);
        setRecommendationSent(true);
    }

    const removeContent = (toRemove) => {
        setContent(content.filter(c => c.contentId !== toRemove.contentId));
    }
    
    const signOut = () => {
        dispatch(setAccessToken(null));
    }
    
    let eventSource = null;

    const onFullEvent = (event) => {
        var recommendation = JSON.parse(event.data);
        setRecommendation(recommendation);
        setEmailStuff(recommendation);
        if(event.type === "final") {
            setGenerating(false);
            eventSource.close();
            eventSource = null;
        }
    };

    const setEmailStuff = (email) => {
        setSubject(email?.subject);
        setBody(email?.body);
        setException(email?.exception);
        setEmailGenerationTook(email?.emailGenerationTook);
    };
    
    const onEmailEvent = (event) => {
        var email = JSON.parse(event.data);
        setEmailStuff(email);
    };
    
    const onEventSourceError = (err) => {
        console.error("EventSource failed:", err);
        eventSource.close();
        setGenerating(false);
        setRecommendationError(err.message);
    };
    
    const generate = async () => {
        try {
            let data = {
                recipients: email.split(",").map(e => e.trim()),
                template: selectedTemplate,
                contentIds: content.map(c => c.contentId),
                allowCache: allowCache
            }
            setGenerating(true);
            setRecommendation(null);
            setRecommendationError(null);
            setRecommendationSent(false);
            setComments("");
            let streamSource = await initRecommendationStream(data);

            eventSource?.close();
            eventSource = new EventSource(streamSource.url);
            eventSource.addEventListener("initial", onFullEvent);
            eventSource.addEventListener("final", onFullEvent);
            eventSource.addEventListener("email", onEmailEvent);
            eventSource.onerror = onEventSourceError;
        }
        catch(e) {
            setRecommendationError(e.message);
            setGenerating(false);
        }
    }
    
    return <>
        <Header signOut={signOut} title="Livesend Email Recommender" navigateTo="/Livesend" />
        <div>
            <div style={{display: "flex", gap: "24px"}}>
                <div style={{width: "23.95%", padding: "8px"}}>
                    <div>
                        <div className="sub-header">1: Search For Content:</div>
                        <div className="meetingPanel">
                            <ContentPicker addContent={addContent} removeContent={removeContent} />
                        </div>
                    </div>
                    <div className="sub-header">2: Setup Email:</div>
                    <div className="meetingPanel">
                        Emails (separated by a comma):
                        <div>
                            <input style={{width: "100%"}} value={email} onChange={(e)=>setEmail(e.target.value)} type="text" />
                        </div>
                    </div>
                    <div className="sub-header">Selected Content:</div>
                    <div className="meetingPanel">
                        <div>
                            {content.length === 0 && <div style={{color: "red"}}>No content selected</div>}
                        {content.map(c => <Content key={c.contentId} {...c} removeContent={removeContent} />)}
                        </div>
                    </div>
                    <div className="sub-header">GPT Template:</div>
                    <div className="meetingPanel">
                        <div style={{width: "100%"}}>
                            <select value={selectedTemplate} onChange={selectedTemplateChanged}>{templates.map(a=><option key={a.key} value={a.value}>{a.key}</option>)}</select>
                        </div>
                        <div>
                            <textarea style={{height: "250px", width: "100%"}} onChange={changeTemplateValue} value={selectedTemplate}></textarea>
                        </div>
                        <small>
                            &lt;Content&gt; will be replaced with the content from the Content section.<br/>
                            &lt;Content1&gt; will be replaced with the first content available.<br/>
                            &lt;ContentDetails&gt; "a link to a PDF", "5 links", etc<br/>
                            &lt;Buyer&gt; will be replaced with info about the buyer if available.<br/>
                            &lt;Seller&gt; will be replaced with the name of the seller.<br/>
                            &lt;SellerTitle&gt; will be replaced with the seller's title (if available).<br/>
                        </small>
                    </div>
                    <div style={{width: "100%"}}>
                        Cached? <Checkbox checked={allowCache} onChange={()=>setAllowCache(!allowCache)} />
                        <Button variant="primary" style={{width: "100%"}} disabled={content.length === 0 || generating} onClick={generate} label="Generate" />
                    </div>
                </div>
                <div style={{width: "40.85%", padding: "8px"}}>
                    <h5 className="pb-2">Email:</h5>
                    <div className="p-2 border-1 border">{generating && <span className="pe-2"><Spinner /></span>}{recommendation == null ? "<-- Please fill out the form and click 'Generate'" : subject ?? <span className="text-primary">No Subject Generated</span>}</div>
                    <div className="p-2 border-1 border" style={{whiteSpace: "pre-wrap"}}>
                        {recommendation == null ? "" : body}
                        {recommendationError && <div className="text-danger">{recommendationError}</div>}
                    </div>
                    {!generating && recommendation && <div className="p-2 border border-1">
                        <div className="d-flex align-items-center justify-content-between">
                            {recommendationSent ? <div className="w-100 p-1 text-success">Thank you for your feedback!</div> :
                            <>
                                <div>How did we do?</div>
                                <div><input style={{width:"450px"}} value={comments} onChange={(e)=>setComments(e.target.value)} placeholder="comments" /></div>
                                <div><Button onClick={()=>sendFeedback("Good")} className="text-success" label="Good" />&nbsp;<Button onClick={()=>sendFeedback("Neutral")} className="text-black-50" label="Neutral" />&nbsp;<Button  onClick={()=>sendFeedback("Bad")} className="text-danger" label="Bad" /></div>
                            </>}
                        </div>
                    </div>}
                    {exception && <div class="text-danger border border-1">Exception: {exception}</div>}
                    {recommendation == null ? null : <small>Content Gathering Took: {recommendation.contentsTook} ms. Contact Lookup Took: {recommendation.contactLookupTook} ms. Email Generation Took: {emailGenerationTook} ms.</small>}
                </div>
                {recommendation == null ? null : <div style={{width: "32.4%", padding: "8px"}}>
                    <h5 className="pb-2">Prompt{recommendation.promptTrimmed && " (Trimmed)"}:</h5>
                    <div className="p-2 border-1 border" style={{whiteSpace: "pre-wrap"}}>
                        {recommendation.prompt}
                    </div>
                    <h5 className="pt-2 pb-2">Content Info:</h5>
                    {recommendation.contents.map(c => <div key={c.contentId} className="card">
                        <div className="card-header">{c.name}</div>
                        <div className="card-body">
                            <span>{c.usedText}</span>    
                        </div>
                    </div>)}
                    <h5 className="pt-2 pb-2">Debug Info:</h5>
                    <div className="p-2 border-1 border">
                        <pre>{JSON.stringify(recommendation, null, 2)}</pre>
                    </div>
                </div>}
            </div>
        </div>
    </>
}